/**
 * AI Strategy Recommendation service — talks to
 * `/api/v1/options/strategy/{symbol}/*` (see
 * `app.api.v1.strategy_recommendation`). Separate from
 * `optionsDashboardService` because this is an independently-versioned
 * feature reading the same underlying tables, not a new section of that
 * service's own response shape.
 */

import api from "@/services/api";
import type {
  PaginatedResponse,
  StrategyRecommendationCurrentResponse,
  StrategyRecommendationHistoryRow,
  StrategyRecommendationTop3Response,
} from "@/types";

export interface StrategyHistoryParams {
  from_date?: string;
  to_date?: string;
  strategy?: string;
  page?: number;
  page_size?: number;
}

export const strategyRecommendationService = {
  async getCurrent(symbol: string): Promise<StrategyRecommendationCurrentResponse> {
    const { data } = await api.get<StrategyRecommendationCurrentResponse>(`/options/strategy/${symbol}/current`);
    return data;
  },

  async getTop3(symbol: string): Promise<StrategyRecommendationTop3Response> {
    const { data } = await api.get<StrategyRecommendationTop3Response>(`/options/strategy/${symbol}/top3`);
    return data;
  },

  async getHistory(
    symbol: string,
    params: StrategyHistoryParams = {}
  ): Promise<PaginatedResponse<StrategyRecommendationHistoryRow>> {
    const { data } = await api.get<PaginatedResponse<StrategyRecommendationHistoryRow>>(
      `/options/strategy/${symbol}/history`,
      { params }
    );
    return data;
  },
};

export default strategyRecommendationService;
